import React, { useRef, useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

import useModeratorCommunities from '@/hooks/useModeratorCommunities';

import './ModeratorDashboard.css';

const NAV_TABS = [
    {
        to: '/moderator/moderation',
        label: 'Moderation',
        icon: 'bi-flag',
    },
    {
        to: '/moderator/members',
        label: 'Members',
        icon: 'bi-people',
    },
];

export default function ModeratorDashboard() {
    const location = useLocation();
    const navRef = useRef(null);
    const [showScrollHint, setShowScrollHint] = useState(false);
    const { moderatorCommunities } = useModeratorCommunities();

    const communityNames = moderatorCommunities
        .map((m) => m.community?.name)
        .filter(Boolean)
        .join(', ');

    useEffect(() => {
        const el = navRef.current;
        if (!el) return;

        const check = () => {
            setShowScrollHint(
                el.scrollLeft + el.clientWidth < el.scrollWidth - 4
            );
        };

        check();
        el.addEventListener('scroll', check);
        window.addEventListener('resize', check);
        return () => {
            el.removeEventListener('scroll', check);
            window.removeEventListener('resize', check);
        };
    }, []);

    return (
        <section id="moderator-dashboard" className="page-container">
            <div className="bg-white border-bottom">
                <div className="d-flex justify-content-center align-items-center gap-3 pt-3 pb-2">
                    <i
                        className="bi bi-shield-check text-primary fs-2"
                        aria-hidden="true"
                    />
                    <div className="text-center">
                        <h1 className="fs-5 fw-bold mb-0">
                            Moderator Dashboard
                        </h1>
                        {communityNames && (
                            <p className="moderator-header-subtitle small mb-0">
                                {communityNames}
                            </p>
                        )}
                    </div>
                </div>

                <div className="moderator-nav-wrapper">
                    <Nav
                        ref={navRef}
                        variant="underline"
                        className="moderator-nav justify-content-md-center px-2 px-md-3 gap-2 gap-md-4 mt-2"
                    >
                        {NAV_TABS.map(({ to, label, icon }) => (
                            <Nav.Item key={label}>
                                <Nav.Link
                                    as={Link}
                                    to={to}
                                    active={location.pathname.startsWith(to)}
                                    className="d-flex align-items-center gap-2"
                                >
                                    <i
                                        className={`bi ${icon}`}
                                        aria-hidden="true"
                                    />
                                    {label}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                    <span
                        className={`moderator-nav-scroll-hint bg-primary rounded-circle d-md-none${showScrollHint ? '' : ' opacity-0'}`}
                        aria-hidden="true"
                    >
                        <i className="bi bi-arrow-right text-white" />
                    </span>
                </div>
            </div>

            <div className="flex-grow-1 overflow-auto bg-primary py-3 py-md-5">
                <Outlet />
            </div>
        </section>
    );
}
